var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { action } from 'mobx';
import { observer } from 'mobx-react';
import { runtime } from '../../../Runtime';
let BrowserModal_ = class BrowserModal_ extends React.PureComponent {
    render() {
        const {} = this.props;
        const { browserModal } = runtime.solidBrowserRuntime;
        if (!runtime.streamedPackages.Lazy)
            return null;
        const { Modal } = runtime.solidPackages.Lazy.components;
        return (React.createElement(Modal, { visible: browserModal.isBrowserModalOpen, onCancel: action(() => (browserModal.isBrowserModalOpen = false)), title: browserModal.browserModalTitle, footer: null, bodyStyle: { padding: 0, background: 'url(/images/loading.gif) center center no-repeat' } },
            React.createElement("iframe", { id: "browsermodal", src: browserModal.browserModalLocation, style: { width: '100%', height: 600, border: 'none', display: 'block' }, key: browserModal.browserModalLocation })));
    }
};
BrowserModal_ = __decorate([
    observer
], BrowserModal_);
export { BrowserModal_ };
